import { defineStore } from "pinia";
import Services from '@/services/woundedServices'
import { mapWounded } from '@/helpers/mapFuncs'
import { assertPersonType } from '@/helpers/personTypeGuard'

export const useWoundedStore = defineStore("wounded", {

state:()=>({
    wounded: {},
    woundeds: [],
}),
getters : {
    getWounded() {
        return mapWounded(this.wounded)
    },
    getWoundeds() {
        return this.woundeds.map(mapWounded)
    }
},
actions : {
    /** Start Sets */
    setWounded(wounded) {
        this.wounded = wounded
    },
    setWoundeds(woundeds) {
        this.woundeds = woundeds
    },
    /** End Sets */

    /** Start Actions */
    get(id) {
        return Services.get(id)
        .then((response)=>{
            this.setWounded(response.data.data)
            return response
        })
    },
    getFamilyByPersonId(id) {
        return Services.getFamilyByPersonId(id)
        .then((response)=>{
            let data = response.data.data.sacrificer;
            data.members = response.data.data.member;
            this.setWounded(data)
            return response
        })
    },
    getProfileDataByPersonId(id) {
        return Services.getProfileDataByPersonId(id)
        .then((response)=>{
            let data = { ...response.data.data.wounded , ...response.data.data, members: response.data.data.familyMembers };
            assertPersonType(data, 2)
            this.setWounded(data)
            return response
        })
    },
    getAll(data) {
        return Services.getAll(data)
        .then((response)=>{
            this.setWoundeds(response.data.data)
            return response
        })
    },
    add(data){
        return Services.add(data)
        .then((response)=>{
            this.woundeds.push(response.data.data)
            return mapWounded(response.data.data)
        })
    },
    edit(id, data){
        return Services.edit(id, data)
        .then((response)=>{
            this.woundeds[this.woundeds.findIndex((x)=>x.id == id)] = response.data.data?.person
            return mapWounded(response.data.data?.person)
        })
    },
    delete(id){
        return Services.delete(id)
        .then((response)=>{
            this.woundeds = this.woundeds.filter((x)=>x.id != id)
            return response
        })
    },
    /** End Actions */
}
});